module.exports = __webpack_public_path__ + "img/markerBusBlue.ba0805b8.svg";